module.exports = __webpack_public_path__ + "img/icon1.2a5dc968.png";